import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from '@angular/core';
import { AssetsPipe } from '@pipes/assets.pipe';
import { ConfigService } from '@services/config.service';
import { FileUploadService } from '@services/fileUpload.service';

@Component({
  selector: 'app-image-upload',
  templateUrl: './image-upload.component.html',
  styleUrls: ['./image-upload.component.scss'],
})
export class ImageUploadComponent {
  @ViewChild('image', { static: true }) fileInput: ElementRef;

  @Input() defaultImage: string;
  @Output() uploadStart = new EventEmitter<any>();
  @Output() uploadComplete = new EventEmitter<string>();

  uploadProgress = 0;
  uploadInProgress = false;

  thumbnailSource = '';

  constructor(
    private appConfig: ConfigService,
    private uploadService: FileUploadService,
    private assetsPipe: AssetsPipe,
  ) {}

  get defaultImageSource() {
    if (this.thumbnailSource) {
      return this.assetsPipe.transform(this.thumbnailSource);
    }
    return this.assetsPipe.transform(
      this.defaultImage || 'image/default_thumbnail.png',
    );
  }

  triggerClick() {
    this.fileInput.nativeElement.click();
  }

  handleFileInput(files: FileList) {
    const targetFile = files.item(0);
    this.upload(targetFile);
  }

  upload(file: File) {
    if (file.size > 30 * 1000 * 1024) {
      alert('Selected image is too large to upload!');
      return;
    }

    this.uploadStart.emit();
    this.uploadProgress = 0;
    this.uploadInProgress = true;

    this.uploadService.upload('/upload', file, {
      success: this.uploadSuccess.bind(this),
      error: this.uploadError.bind(this),
    });
  }

  uploadSuccess(data) {
    this.uploadInProgress = false;
    this.thumbnailSource = data.Key;
    this.uploadComplete.emit(data.Key);
  }

  uploadError(error) {
    console.error(error);
  }
}
